import aboutUsImage from "../assets/about-us.png";
import "./container.css";
import "./AboutIntro.css";

const AboutIntro = () => {
  return (
    <section className="about-intro">
      <div className="container-8xl about-intro-grid">
        <div>
          <span
            className="about-intro-badge font-['Inter'] font-[500]"
            style={{ fontStyle: "normal", color: "rgba(0, 0, 0, 0.55)" }}
          >
            About Us
          </span>

          <h2
            className="about-intro-heading font-['Inter'] font-[500]"
            style={{ fontStyle: "normal", color: "#252525" }}
          >
            One Step Closer to Financial Freedom.
          </h2>

          <p
            className="about-intro-text font-['Inter'] font-[400]"
            style={{ fontStyle: "normal", color: "#5A5A60" }}
          >
            At EMI Saathi, we help you bring multiple debts together into one simpler repayment
            plan, making it easier to manage your money, reduce financial stress, and move
            forward with confidence.
          </p>
        </div>

        <img
          src={aboutUsImage}
          alt="Two people shaking hands after a successful loan consolidation"
          className="about-intro-image"
        />
      </div>
    </section>
  );
};

export default AboutIntro;
